import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-blankspace',
  templateUrl: './common-blankspace.component.html',
  styleUrls: ['./common-blankspace.component.css']
})
export class CommonBlankspaceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
